import { z } from 'zod';

// Primitive and Array types
const primitiveSchema = z.union([z.string(), z.number(), z.boolean(), z.null()]);
const arraySchema = z.array(primitiveSchema);

// Define operator schemas
const operatorsSchema = z.object({
    $in: z.array(primitiveSchema).optional(), // $in expects an array
    $nin: z.array(primitiveSchema).optional(), // $nin expects an array
    $exists: z.boolean().optional(), // $exists expects a boolean
    $gte: primitiveSchema.optional(), // $gte expects a number/string
    $gt: primitiveSchema.optional(), // $gt expects a number/string
    $lte: primitiveSchema.optional(), // $lte expects a number/string
    $lt: primitiveSchema.optional(), // $lt expects a number/string
    $eq: primitiveSchema.optional(), // $eq expects a primitive
    $ne: primitiveSchema.optional(), // $ne expects a primitive
    $mod: z.tuple([z.number(), z.number()]).optional(), // $mod expects an array of two numbers
    $all: z.array(primitiveSchema).optional(), // $all expects an array
    $and: z.array(z.lazy(() => SiftQuerySchema)).optional(), // $and expects an array of queries
    $or: z.array(z.lazy(() => SiftQuerySchema)).optional(), // $or expects an array of queries
    $nor: z.array(z.lazy(() => SiftQuerySchema)).optional(), // $nor expects an array of queries
    $not: z.lazy(() => SiftQuerySchema).optional(), // $not expects a query object
    $size: z.number().optional(), // $size expects a number
    $type: z.enum(['string', 'number', 'boolean', 'array', 'object']).optional(), // $type expects a type
    $regex: z.string().optional(), // $regex expects a RegExp
    $where: z.function().optional(), // $where expects a function
    $elemMatch: z.lazy(() => SiftQuerySchema).optional(), // $elemMatch expects a query
});

// Schema for a single query, combining operators
export const SiftQuerySchema = z.record(
    z.union([
        primitiveSchema, // Direct match of a primitive
        arraySchema, // Direct match of an array
        operatorsSchema, // Operators
    ]),
);
